import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions } from '../../../../../store/actions'
import PopTax from './PopTax'
import history from '../../../../../route/history'
import moment from 'moment'
import { commons } from '../../../../../hook/common'

/**
 * 구매확인서 4단계 / 세금계산서 정보
 */
const Step04 = (props) => {
  const [docid, setDocid] = useState()
  const [taxList, setTaxList] = useState(props.stepData)
  const [showAddTax, setShowAddTax] = useState(false)

  /**
   * 페이지 진입
   */
  useEffect(() => {
    let id = props.search?.split('=')[1]
    let key = props.search?.split('=')[0]

    if (id && key === '?id') {
      let data = JSON.parse(sessionStorage.getItem(id))

      //이전 페이지 정보가 없을 경우 첫 화면으로 이동
      if (!data || data?.step3?.length <= 0) {
        history.replace('/service/certapply/1?id=' + id)
        return
      }

      setDocid(id)
      setTaxList(data.step4)
    } else {
      if (props.packageId === 0) {
        history.replace('/service/certapply/1')
      }
      if (props.packageId > 0) {
        let data = JSON.parse(sessionStorage.getItem(props.packageCrtfNo))
        setDocid(props.packageCrtfNo)
        setTaxList(data.step4)
      }
    }
  }, [])

  /**
   * 데이터 갱신
   */
  useEffect(() => {
    if (props.isCalled === true) {
      setTaxList(props.stepData)
    }
    props.setCalled(false)
  }, [props?.isCalled])

  return (
    <React.Fragment>
      {showAddTax && <PopTax onClose={() => setShowAddTax(false)} docid={docid} />}

      <h3 className="h3-tit mt30">세금계산서</h3>
      <p className="text-box">외화획득용 원료 · 기재를 구매한 자가 신청하는 경우에만 해당합니다.</p>
      <div className="list-header mt20">
        <span className="total-num">총 {taxList?.length}건</span>
        <span className="right">
          <a
            href="#"
            className="btn-secondary sm"
            onClick={(e) => {
              e.preventDefault()
              setShowAddTax(true)
            }}
          >
            세금계산서 등록 / 수정
          </a>
        </span>
      </div>
      <div className="tbl-wrap">
        <table className="tbl-list">
          <caption>세금계산서번호, 품명, 규격, 공급가액, 세액, 수량, 선적기일 항목으로 구성</caption>
          <colgroup>
            <col style={{ width: '14%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '12%' }} />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">세금계산서번호</th>
              <th scope="col">품명</th>
              <th scope="col">규격</th>
              <th scope="col">공급가액</th>
              <th scope="col">세액</th>
              <th scope="col">수량</th>
              <th scope="col">작성일자</th>
            </tr>
          </thead>
          <tbody>
            {taxList?.length > 0 ? (
              taxList?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="cell" data-title={'세금계산서번호'}>
                      {item.taxNo}
                    </td>
                    <td className="cell" data-title={'품명'}>
                      {item.itemnm}
                    </td>
                    <td className="cell" data-title={'규격'}>
                      {item.itemdeftxt}
                    </td>
                    <td className="cell" data-title={'공급가액'}>
                      {commons.addComma(item.splyAmt)}
                    </td>
                    <td className="cell" data-title={'세액'}>
                      {commons.addComma(item.taxAmt)}
                    </td>
                    <td className="cell" data-title={'수량'}>
                      {item?.itemqty && commons.addComma(item.itemqty)} {item?.itemqtyunitcd}
                    </td>
                    <td className="cell" data-title={'작성일자'}>
                      {moment(item.writedt).format('Y-M-D')}
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className="nodata">등록된 자료가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="list-footer">
        <span className="left">
          <a
            href="#"
            className="btn-secondary md"
            onClick={(e) => {
              e.preventDefault()
              props.doDelete()
            }}
          >
            취소
          </a>
        </span>
        <span className="right">
          <a
            href="#"
            className="btn-secondary md"
            onClick={(e) => {
              e.preventDefault()
              props.goStepPrev()
            }}
          >
            이전
          </a>
          <a
            href="#"
            className="btn-primary md"
            onClick={(e) => {
              e.preventDefault()
              props.goStepNext()
            }}
          >
            다음
          </a>
        </span>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.certapply?.data?.step4,
    totalData: state.certapply.data,
    isCalled: state.certapply.isCalled,
  }
}

const actionCreators = {
  setCalled: certapplyActions.setCalled,
  alert: certapplyActions.alert,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(Step04)
